import CountUp from 'react-countup';
import { FaHeadset, FaSmileWink, FaTasks, FaUsers } from 'react-icons/fa';

const Facts = () => {
    const facts = [
        { title: 'Clients', number: 4, icon: FaSmileWink, id: 1 },
        { title: 'Projects', number: 55, icon: FaTasks, id: 2 },
        { title: 'Hour', number: 6720, icon: FaHeadset, id: 3 },
        { title: 'Company', number: 4, icon: FaUsers, id: 4 }
    ]
    return (
        <section className="ourValue">
            <div className="row container mx-auto">
                {
                    facts.map(({ title, number, icon: Icon, id }) => {
                        return (<div className="col-md-6 col-lg-3" key={id}>
                            <div className="ourValueDetails">
                                <span className={`valueIcon valueIcon${id}`}>
                                    <Icon />
                                </span>
                                <div>
                                    <p className="ourValueTitle">{title}</p>
                                    <h4 className="ourValueNumber">
                                        <CountUp
                                            end={number}
                                            start={0}
                                            duration={5}
                                            delay={5}
                                        />
                                    </h4>
                                </div>
                            </div>
                        </div>)
                    })
                }
            </div>
        </section>
    );
};

export default Facts;